import { defineMessages } from 'react-intl';

const messages = defineMessages({
  updated: '已更新',
  from: '从',
  to: '变更为',
  setTo: '被设置为',
  deleted: '被删除',
  added: '已添加',
  cost: '用时',
  lasest: '最新',
});

export default messages;
